<template>
  <div>
    <h3 class="form-title">✏️ 新增支出</h3>
    <form @submit.prevent="addevent" class="styled-form">
      <div class="form-group">
        <label>支出類別</label>
        <select v-model="curritem1" required>
          <option v-for="x in pitem" :key="x" :value="x">{{ x }}</option>
        </select>
      </div>
      <div class="form-group">
        <label>付款方式</label>
        <select v-model="curritem2" required>
          <option v-for="x in payment" :key="x" :value="x">{{ x }}</option>
        </select>
      </div>
      <div class="form-group">
        <label>金額</label>
        <div class="input-prefix">
          <span class="prefix">$</span>
          <input type="number" v-model="cost" placeholder="0" required />
        </div>
      </div>
      <div class="form-group">
        <label>備註</label>
        <textarea v-model="btext" placeholder="輸入備註（可選）" rows="2"></textarea>
      </div>
      <label class="checkbox-row">
        <input type="checkbox" v-model="yesterday" />
        <span>記錄為前一日</span>
      </label>
      <button type="submit" class="btn-submit" :disabled="adding">
        {{ adding ? '新增中...' : '💾 新增記錄' }}
      </button>
    </form>
    <div v-if="success" class="toast toast-success">✅ 記錄已新增！</div>
  </div>
</template>

<script>
import axios from 'axios'
axios.defaults.baseURL = 'https://mb.kman.idv.tw:9579/';

export default {
  data() {
    return {
      pitem: [],
      payment: [],
      curritem1: null,
      curritem2: null,
      cost: null,
      btext: '',
      token: null,
      yesterday: false,
      adding: false,
      success: false
    };
  },
  async mounted() {
    const response1 = await axios.get('get_pay_item', {
      headers: { Authorization: `Bearer ${this.$store.getters.setToken}` }
    });
    this.pitem = response1.data;
    const response2 = await axios.get('get_transfer_item', {
      headers: { Authorization: `Bearer ${this.$store.getters.setToken}` }
    });
    this.payment = response2.data;
    this.curritem1 = this.pitem[0];
    this.curritem2 = this.payment[0];
  },
  methods: {
    async addevent() {
      this.adding = true;
      try {
        await axios.post('addevent', {
          curritem1: this.curritem1,
          curritem2: this.curritem2,
          cost: this.cost,
          btext: this.btext,
          token: this.$store.getters.setToken,
          yesterday: this.yesterday
        });
        this.cost = null;
        this.btext = '';
        this.yesterday = false;
        this.success = true;
        setTimeout(() => { this.success = false; }, 2500);
      } catch (e) {
        alert('新增失敗');
      } finally {
        this.adding = false;
      }
    }
  }
};
</script>
<style scoped>
.form-title { font-size: 17px; font-weight: 700; margin-bottom: 20px; }
.styled-form { display: flex; flex-direction: column; gap: 14px; }
.form-group { display: flex; flex-direction: column; gap: 5px; }
.form-group label { font-size: 13px; font-weight: 600; color: var(--text-light); }
.form-group select,
.form-group input,
.form-group textarea {
  padding: 10px 12px;
  font-size: 15px;
  border: 1px solid var(--border);
  border-radius: 8px;
  outline: none;
  background: #fff;
  transition: border-color 0.15s;
}
.form-group select:focus,
.form-group input:focus,
.form-group textarea:focus {
  border-color: var(--primary);
  box-shadow: 0 0 0 3px rgba(79,70,229,0.1);
}
.form-group textarea { resize: none; }
.input-prefix { position: relative; }
.input-prefix .prefix {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--text-light);
  font-size: 16px;
}
.input-prefix input { padding-left: 30px; width: 100%; }
.checkbox-row {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-size: 14px;
  color: var(--text);
}
.checkbox-row input[type="checkbox"] { width: 18px; height: 18px; accent-color: var(--primary); }
.btn-submit {
  padding: 12px;
  font-size: 15px;
  font-weight: 600;
  background: var(--primary);
  color: #fff;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.15s;
  margin-top: 4px;
}
.btn-submit:hover { background: var(--primary-hover); }
.btn-submit:disabled { opacity: 0.6; cursor: not-allowed; }
.toast {
  margin-top: 14px;
  padding: 10px 16px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  text-align: center;
  animation: fadeIn 0.3s;
}
.toast-success { background: #ecfdf5; color: #065f46; border: 1px solid #a7f3d0; }
@keyframes fadeIn { from { opacity: 0; transform: translateY(-6px); } to { opacity: 1; transform: translateY(0); } }
</style>
